//
// Embedded iframe
//
// Open links in new tab ( prevent opening inside iframe )
//

// Delegate function helper
function on(rootEl, eventName, selector, fn) {
  const element = rootEl.querySelector ? rootEl : document.querySelector(rootEl);

  // eslint-disable-next-line consistent-return
  element.addEventListener(eventName, (event) => {
    const possibleTargets = element.querySelectorAll(selector);
    const { target } = event;

    for (let i = 0, l = possibleTargets.length; i < l; i++) {
      let el = target;
      const p = possibleTargets[i];

      while (el && el !== element) {
        if (el === p) {
          return fn(p, event);
        }

        el = el.parentNode;
      }
    }
  });
}

function reLink(el) {
  // remove all data attributes
  Object.keys(el.dataset).forEach(item => el.removeAttribute(`data-${item}`));

  // relink
  const href = $(el).closest('bu-card').find('[slot="title"] a').attr('href');
  el.setAttribute('href', href);
}

on(document, 'click', 'a', element => element.setAttribute('target', '_blank'));
// Set all links to target blank, so they don't open inside an iframe

if (App.config.user.id) {
  // If current user, relink report as inappropriate link to match card show page
  on(document, 'click', '.card-comment-actions a:last-child', element => reLink(element));
} else {
  // If not current user, relink links inside card-body and card-footer to match card show page
  on(document, 'click', '.card-footer a, .card-body div:not(.short) a', element => reLink(element));
}
